import { render, staticRenderFns } from "./addbanner.vue?vue&type=template&id=c0ca7ae2&scoped=true&"
import script from "./addbanner.vue?vue&type=script&lang=js&"
export * from "./addbanner.vue?vue&type=script&lang=js&"
import style0 from "./addbanner.vue?vue&type=style&index=0&id=c0ca7ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ca7ae2",
  null
  
)

export default component.exports